import PropTypes from 'prop-types';
import React from 'react';
import { FDStack } from '@facet-wealth/design';
import TitleWithRequired from 'Components/ComponentLibrary/Molecules/TitleWithRequired/TitleWithRequired';
import LabellessSelectField from 'Components/ComponentLibrary/Components/Uncategorized/LabellessSelectField';

function SelectFieldWithLabelAbove({
  SelectProps, required, label, ...rest
}) {
  return (
    <FDStack direction={'column'} spacing={1}>
      <TitleWithRequired text={label} required={required} />
      <LabellessSelectField
        SelectProps={SelectProps}
        required={required}
        label={label}
        {...rest}
      />
    </FDStack>
  );
}

SelectFieldWithLabelAbove.defaultProps = {
  SelectProps: {},
  required: 'false',
  label: '',
};

SelectFieldWithLabelAbove.propTypes = {
  SelectProps: PropTypes.object,
  required: PropTypes.bool,
  label: PropTypes.string,
};

export default SelectFieldWithLabelAbove;
